import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ScanLine, X, ArrowRight } from 'lucide-react';
import './ScanSuggestionModal.css';

// Upload error codes that mean "this PDF needs OCR", each with its own explanation.
export const SCAN_SUGGESTION_CODES = ['DOCUMENT_TOO_SHORT', 'PDF_TEXT_UNREADABLE', 'PDF_IS_SCAN'];

function ScanSuggestionModal({ isVisible, reason, onClose }) {
  const { t } = useTranslation('chat');
  const navigate = useNavigate();

  if (!isVisible) return null;

  const goToScan = () => {
    onClose();
    navigate('/scans');
  };

  return (
    <div className="scan-suggestion-overlay" onClick={onClose}>
      <div className="scan-suggestion-modal" onClick={(e) => e.stopPropagation()}>
        <button className="scan-suggestion-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="scan-suggestion-icon">
          <ScanLine size={48} />
        </div>

        <h2 className="scan-suggestion-title">{t('scanSuggestion.title')}</h2>
        <p className="scan-suggestion-message">{t(`scanSuggestion.description.${reason}`)}</p>

        <button className="scan-suggestion-button" onClick={goToScan}>
          {t('scanSuggestion.goToScan')}
          <ArrowRight size={20} />
        </button>

        <button className="scan-suggestion-dismiss" onClick={onClose}>
          {t('scanSuggestion.dismiss')}
        </button>
      </div>
    </div>
  );
}

export default ScanSuggestionModal;
